// extracted by mini-css-extract-plugin
module.exports = {"button":"GlobalSearch_button__37YZg","content":"GlobalSearch_content__3uutg"};